import React, { useState, useEffect } from "react";
import { Toaster, toast } from "react-hot-toast";
import Layout from "../../shared/Layout";
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { DeleteLoginDetailById, GetLoginDetailAll } from "../../../_services";
import { handleExport } from "../../../_services/excelExportService";

// const baseUrl = process.env.REACT_APP_BASE_URL;

const CustomerList = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    // const [productData, setProductData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [customerData, setCustomerData] = useState([]);

    const fetchLoginDetailAll = async () => {
        try {
            const data = await GetLoginDetailAll();
            if (data.isSuccess === 200) {
                setCustomerData((prevData) => {
                    if (JSON.stringify(prevData) !== JSON.stringify(data?.data)) {
                        const sortedData = data?.data?.sort((a, b) => {
                            return new Date(b.createdDate) - new Date(a.createdDate);
                        });

                        return sortedData;
                    }
                    return prevData;
                })
                setLoading(false);
            }
        } catch (error) {
            setCustomerData([]);
        }
    };

    const onDeleteLoginDetail = async (id) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this item?");

        if (!isConfirmed) {
            return;
        }
        const data = await DeleteLoginDetailById(id);
        if (data.isSuccess === 200) {
            fetchLoginDetailAll();
            toast.success("Delete Successfully");
        }
    };

    useEffect(() => {
        fetchLoginDetailAll();
    }, []);

    useEffect(() => {
        if (searchTerm) {
            const filtered = customerData.filter(item =>
                item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.emailId.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(customerData);
        }
    }, [searchTerm, customerData]);

    const onCustomerDetail = (loginId) => {
        localStorage.setItem('CustomerId', loginId)
        navigate(`/customerdetail/${loginId}`);
    };

    const excelSheetData = customerData.map((item, index) => ({
        Index: index + 1, // Adding an index starting from 1
        Name: item.name,
        EmailId: item.emailId,
        MobileNo: item.mobileNo,
        TotalOrder: item.productOrderCount
    }));

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '70px'
        },
        {
            name: 'Customer name',
            selector: row => (
                <span onClick={() => onCustomerDetail(row?.loginId)} className="name_customer">
                    {row.name}
                </span>
            ),
            sortable: true,
            minWidth:'150px'
        },
        {
            name: 'Contact info',
            selector: row => (
                <div className="email_mobile">
                    {/* Email: Clicking will open the default email client */}
                    <h6>
                        <a href={`mailto:${row.emailId}`} onClick={(e) => e.preventDefault()}>{row.emailId}</a>
                    </h6>

                    {/* Mobile: Clicking will initiate a phone call */}
                    <p className="mb-0">
                        <a href={`tel:${row.mobileNo}`} onClick={(e) => e.preventDefault()}>{row.mobileNo}</a>
                    </p>
                </div>
            ),
            sortable: false,
            minWidth:'250px'
        },
        {
            name: 'Total Order',
            selector: row => (
                <div className="">
                    <span>{row?.productOrderCount}</span>
                </div>
            ),
            sortable: false
        },
        {
            name: 'Registration Date',
            selector: row => {
                if (row.createdDate) {
                    const date = new Date(row.createdDate);

                    // Convert to Indian Standard Time (IST)
                    const indianTime = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));

                    // Format Date as dd/mm/yyyy
                    const day = String(indianTime.getDate()).padStart(2, '0');
                    const month = String(indianTime.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
                    const year = indianTime.getFullYear();

                    return `${day}/${month}/${year}`;
                } else {
                    return 'N/A';
                }
            },
            sortable: true,
            width: '180px'
        },
        {
            name: 'Action',
            cell: row => (
                <div className="d-flex" style={{ gap: "10px" }}>
                    <span title='View' onClick={() => onCustomerDetail(row?.loginId)} className="edit_icon_wepper">
                        <i className="fas fa-eye"></i>
                    </span>
                    <span title='Delete' onClick={() => onDeleteLoginDetail(row.loginId)} className="delete_icon_weepr">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                            <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" fill="#FF0000"></path>
                        </svg>
                    </span>
                </div>
            ),
            sortable: false
        }
    ];

    return (
        <Layout>
            <div className="px-4">
                <div className="admin-page mt-4 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading d-flex align-items-center" style={{ gap: "10px" }}>
                        <img src="./images/customer.png" style={{ width: '25px' }} alt="" />
                        <h4 className="mb-0">Customer List {`(${customerData?.length})`}</h4>
                    </div>
                    <div className="d-md-flex align-items-center" style={{ gap: "20px" }}>
                        <div className="search-container ">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="form-control"
                            />
                        </div>
                        <button className="export_button" onClick={() => handleExport(excelSheetData)}><img src="./images/upload.png" alt="" className="export_icon" /><span>Export</span></button>
                    </div>
                </div>

                <div className="datatable mt-4">
                    <DataTable
                        columns={columns}
                        data={filteredData || []}
                        progressPending={loading}
                        progressComponent={<p>Loading...</p>}
                        pagination
                        highlightOnHover
                    />
                </div>

                <Toaster position="top-right" />
            </div>
        </Layout>
    )
}

export default CustomerList;